var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAvancar01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2284_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1309_1_",
    d: "M1.1,18.9c1.9-6,7.8-10.2,15-10.3V1.6c0-0.3,0.3-0.6,0.6-0.6c0.1,0,0.3,0,0.4,0.1l18.1,13.1 c0.3,0.2,0.3,0.6,0.1,0.8c0,0,0,0,0,0l-0.1,0.1l-18.1,13c-0.3,0.2-0.6,0.1-0.9-0.1c-0.1-0.1-0.1-0.2-0.1-0.4v-7 c-4.4,0-8.1,2.1-9.4,5.2c-1.1,2.7-0.2,5.6,2.4,8c0.2,0.2,0.3,0.6,0.1,0.8c0,0,0,0,0,0C9,34.9,8.8,35,8.7,35H8.2 c-0.1,0-0.2,0-0.3-0.1C1.9,30.9-0.7,24.8,1.1,18.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAvancar01);
export default __webpack_public_path__ + "static/media/ico-avancar-01.233ecaceee457d398fce20d6959dda3b.svg";
export { ForwardRef as ReactComponent };